module.exports = __webpack_public_path__ + "static/default-eb44ca3312b98f121e9b9bc220df3a04.jpg";